import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import { toaster } from "@/utilities/toaster";
import { ScriptModule } from "@/store/modules/script.module";
import copy from "copy-to-clipboard";
//SYSTEMONE
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
setInteractionMode("eager");
Component.registerHooks(["beforeRouteEnter"]);
let ScriptManager = /** @class */ (() => {
    let ScriptManager = class ScriptManager extends Vue {
        constructor() {
            super(...arguments);
            this.title = "Script Manager";
            this.moduleId = 0;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Developer Tools",
                    href: "#",
                },
                {
                    text: "Script Manager",
                    active: true,
                },
            ];
        }
        async beforeRouteEnter(to, from, next) {
            next();
        }
        generateCSharp() {
            ScriptModule.GetCSharpScript(this.moduleId).then((response) => { });
        }
        generateSqlScript() {
            ScriptModule.GetSqlScript(this.moduleId).then((response) => { });
        }
        generateTsScript() {
            ScriptModule.GetTsScript(this.moduleId).then((response) => { });
        }
        copyText() {
            if (this.cSharpScript.script != "") {
                copy(this.cSharpScript.script);
                toaster.ShowSuccess("Copied to clipboard.");
            }
            else {
                toaster.ShowError("Generate CSharp or Sql or Enum Script Manager");
            }
        }
        get cSharpScript() {
            return ScriptModule.cSharpScript;
        }
        get sqlscript() {
            return ScriptModule.cSharpScript;
        }
        created() {
            this.$nextTick(function () {
                this.moduleId = 0;
            });
            ScriptModule.GetCSharpScript("0");
        }
    };
    ScriptManager = __decorate([
        Component({
            name: "ScriptManager",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], ScriptManager);
    return ScriptManager;
})();
export default ScriptManager;
